module.exports = __webpack_public_path__ + "img/HFF-Anniversary-FB-Group-Cover-1640x85-1.d5c594e4.jpg";